module.exports = __webpack_public_path__ + "static/media/location-icon-white.f13ee30b.svg";